export type MenuLanguage = 'es' | 'en-US' | 'en-GB' | 'fr';
export type GraphicsQuality = 'auto' | 'low' | 'medium' | 'high';
export type MenuControlScheme = 'mouse' | 'wasd' | 'touch';

export function getDefaultControlScheme(): MenuControlScheme {
  const touchDevice = typeof window !== 'undefined'
    && (window.matchMedia('(pointer: coarse)').matches || navigator.maxTouchPoints > 0);
  return touchDevice ? 'touch' : 'wasd';
}

export function getInitialControlScheme(): MenuControlScheme {
  try {
    const saved = JSON.parse(localStorage.getItem('pushio_menu_settings') || '{}').controlScheme;
    return saved === 'wasd' || saved === 'mouse' || saved === 'touch'
      ? saved
      : getDefaultControlScheme();
  } catch {
    return getDefaultControlScheme();
  }
}

export interface MenuSettings {
  language: MenuLanguage;
  controlScheme: MenuControlScheme;
  mouseSensitivity: number;
  vibration: boolean;
  soundVolume: number;
  musicVolume: number;
  graphicsQuality: GraphicsQuality;
  showFps: boolean;
  showPing: boolean;
  reduceCameraShake: boolean;
}

export const DEFAULT_MENU_SETTINGS: MenuSettings = {
  language: 'es',
  controlScheme: 'wasd',
  mouseSensitivity: 1,
  vibration: true,
  soundVolume: 0.5,
  musicVolume: 0.35,
  graphicsQuality: 'auto',
  showFps: false,
  showPing: true,
  reduceCameraShake: false,
};

export interface ServerStats {
  sessions: number;
  rooms: number;
  queue: number;
  ping: number;
}
